import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncCompassTableCrossFlowTouchPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-compass-cross-flow-table-touchpoint" */ './main').then(
			(module) => module.AsyncCompassTableCrossFlow,
		),
	),
	getPreloadProps: () => ({}),
});
